import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=5a4d2fdd"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports